import React, { useEffect } from 'react';
import { get } from 'lodash';

import { FIELD_PATHS, YES_NO_OPTIONS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { useAnalytics } from '@funnels/providers';
import { HomeLoanLiability, LiabilityEntityIndex } from '@funnels/types';

import { RadioButtonsField } from '../../Fields';
import { EditableViewProps } from '../types';

interface TopUpRadioButtonsProps extends EditableViewProps, LiabilityEntityIndex {}

const onlyOneTopUpValidation = (value: boolean, formValues?: Object) => {
  const topUpsCounts = (get(formValues, FIELD_PATHS.LIABILITIES(), []) as HomeLoanLiability[]).filter((liability) => {
    return liability.toBeToppedUp;
  }).length;

  if (value && topUpsCounts > 1) {
    return 'You can only apply an increase to one split per application';
  }

  return '';
};

export const TopUpRadioButtonsEditableView = (props: TopUpRadioButtonsProps) => {
  const { tracking } = useAnalytics();
  const { liabilityIndex } = props;
  const [formValues, setFormValue] = useFormValues();
  const selectedValue = get(formValues, FIELD_PATHS.LIABILITY_TO_BE_TOPPED_UP(liabilityIndex));

  useEffect(() => {
    if (selectedValue === undefined) {
      // turn the setFormValue to an async method with 0 delay to make sure it will write the value correctly
      // LIABILITY_TO_BE_TOPPED_UP is always default by false
      setTimeout(() => {
        setFormValue(FIELD_PATHS.LIABILITY_TO_BE_TOPPED_UP(liabilityIndex), false);
      }, 0);
    }
  }, [liabilityIndex, selectedValue]);

  const handleTracking = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = e.target.value;
    const selection =
      YES_NO_OPTIONS.find((option) => {
        return option.value === selectedValue;
      })?.label || '';
    tracking?.radio({ title: 'Apply top up to this split', selection, position: 'Property - Current Loan' });
  };

  return (
    <RadioButtonsField
      label="Apply top up to this split"
      name={FIELD_PATHS.LIABILITY_TO_BE_TOPPED_UP(liabilityIndex)}
      direction="row"
      radios={YES_NO_OPTIONS}
      selectedValue={selectedValue}
      validate={onlyOneTopUpValidation}
      onChange={handleTracking}
    />
  );
};
